var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.615 11.343l5.494-6.94a1.045 1.045 0 0 1 1.492-.161c.461.382.532 1.066.163 1.532l-6.193 7.824c-.24.302-.605.439-.957.394a1.046 1.046 0 0 1-.692-.304l-3.598-3.555a1.103 1.103 0 0 1-.026-1.535 1.046 1.046 0 0 1 1.506-.032l2.81 2.777z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNjE1IDExLjM0M2w1LjQ5NC02Ljk0YTEuMDQ1IDEuMDQ1IDAgMCAxIDEuNDkyLS4xNjFjLjQ2MS4zODIuNTMyIDEuMDY2LjE2MyAxLjUzMmwtNi4xOTMgNy44MjRjLS4yNC4zMDItLjYwNS40MzktLjk1Ny4zOTRhMS4wNDYgMS4wNDYgMCAwIDEtLjY5Mi0uMzA0bC0zLjU5OC0zLjU1NWExLjEwMyAxLjEwMyAwIDAgMS0uMDI2LTEuNTM1IDEuMDQ2IDEuMDQ2IDAgMCAxIDEuNTA2LS4wMzJsMi44MSAyLjc3N3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgCheck18 as ReactComponent };